export default __webpack_public_path__ + "static/media/home-branding-agency-testimonial-bg.7abae04b.jpg";